import { createContext, useContext, useEffect, useState } from "react";

import { request } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => window.localStorage.getItem("rohm_access_token"));
  const [user, setUser] = useState(null);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    async function loadProfile() {
      if (!token) {
        setIsChecking(false);
        return;
      }
      try {
        const profile = await request("/auth/me", {}, token);
        setUser(profile);
      } catch {
        window.localStorage.removeItem("rohm_access_token");
        setToken(null);
      } finally {
        setIsChecking(false);
      }
    }
    loadProfile();
  }, [token]);

  async function sendOtp(email) {
    return request("/auth/request-otp", {
      method: "POST",
      body: JSON.stringify({ email }),
      headers: { "X-Forwarded-Host": window.location.hostname },
    });
  }

  async function verifyOtp(email, otp) {
    const result = await request("/auth/verify-otp", { method: "POST", body: JSON.stringify({ email, otp }) });
    window.localStorage.setItem("rohm_access_token", result.access_token);
    setToken(result.access_token);
    setUser(result.user);
    return result;
  }

  async function sendMobileOtp(mobile) {
    return request("/auth/request-mobile-otp", {
      method: "POST",
      body: JSON.stringify({ mobile }),
      headers: { "X-Forwarded-Host": window.location.hostname },
    });
  }

  async function verifyMobileOtp(mobile, otp) {
    const result = await request("/auth/verify-mobile-otp", { method: "POST", body: JSON.stringify({ mobile, otp }) });
    window.localStorage.setItem("rohm_access_token", result.access_token);
    setToken(result.access_token);
    setUser(result.user);
    return result;
  }

  function signOut() {
    window.localStorage.removeItem("rohm_access_token");
    setToken(null);
    setUser(null);
  }

  return <AuthContext.Provider value={{ token, user, isChecking, sendOtp, verifyOtp, sendMobileOtp, verifyMobileOtp, signOut }}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within AuthProvider.");
  }
  return context;
}